<div class="title">
    <span>{{ 'realtime:usergroups_details_profile' | i18next }}</span>
    <i id="close-btn-profile-dialog" class="close-icon" mat-button cdkFocusInitial [mat-dialog-close]="false" (click)="closeDialog()"></i>
</div>

<div class="dialog-content">
    <div *ngFor="let profile of profiles">
        <div *ngIf="profile.qualities.length > 0">
            <div class="profile-info">
            <p>
            <span class="bold">{{ 'realtime:profile_serviceNumber' | i18next }}</span><br />
            {{ profile.serviceNumber }}
            </p>

            <p>
            <span class="bold">{{ 'realtime:profile_description' | i18next }}</span><br />
            {{ profile.serviceDescription || '' }}
            </p>


            </div>
             <!-- Replace UL with Table -->
            <table class="full-width-table">
                <tbody>
                    <tr class="mat-mdc-row" *ngFor="let quality of sortQualitiesByName(profile.qualities)">
                        <td >{{ quality.name }}</td>
                        <td class="text-right">{{ quality.userLevel }}</td>
                    </tr>
                </tbody>
            </table>
            <p>
              <span class="profile_skill">{{ 'realtime:profile_skill' | i18next }} {{ 'realtime:profile_skillscore' | i18next }}</span><br />
            </p>
        </div>
    </div>
</div>

